import { ToastOptions } from '@ionic/react'
import { HookOverlayOptions } from '@ionic/react/dist/types/hooks/HookOverlayOptions'
import { checkbox, warning } from 'ionicons/icons'

export const onCopyContent = (
  presentToast: {
    (message: string, duration?: number | undefined): Promise<void>
    (options: ToastOptions & HookOverlayOptions): Promise<void>
  },
  data: {
    content: string
    successMsg: string
    failureMsg: string
  },
) => {
  try {
    navigator.clipboard.writeText(data.content)
    presentToast({
      message: data.successMsg,
      duration: 1500,
      position: 'top',
      color: 'primary',
      icon: checkbox,
    })
  } catch {
    presentToast({
      message: data.failureMsg,
      duration: 1500,
      position: 'top',
      color: 'danger',
      icon: warning,
    })
  }
}
